jQuery(document).ready(function($) {
    if (typeof stripePaymentData != 'undefined') {

        var stripe = Stripe(stripePaymentData.pk);

        // global function to enable or disable loading animation of all payment buttons
        var handleLoadingButtons = function(enable) {
            $('.dnPaymentSelect-button').each(function() {
                $(this).enableLoadingAnimation(enable);
            });
        };

        var checkAvailabilityThen = function(callback) {
            fetch(stripePaymentData.checkAvailabilityUrl, {
                method: "GET",
                redirect: "follow"
            }).then((response) => {
               if (response.url === stripePaymentData.checkAvailabilityUrl) {
                   callback();
               } else {
                   window.location = stripePaymentData.checkAvailabilityUrl;
               }
            });
        }

        /*
            Handles Sources API
        */

        function handleSourceActivation(sourceData) {
            stripe.createSource(sourceData).then(function (result) {

                var source = result.source;

                switch (source.flow) {
                    case 'redirect':
                        window.location.replace(source.redirect.url);
                        break;
                    case 'code_verification':
                        break;
                    default:
                        break;
                }
            });
        }

        // handle giropay with sources

        $(document).on('click', '#dnPaymentStripe-giropay', function (e) {

            $(this).enableLoadingAnimation(true);

            // prevent PayPal availability check to meddle with the stripe checkout
            if (!window.checkoutInProgress) {
                window.checkoutInProgress = true;
            }

            var sourceData = {
                type: 'giropay',
                amount: stripePaymentData.amount,
                currency: 'eur',
                owner: {
                    name: stripePaymentData.lastname,
                },
                redirect: {
                    return_url: stripePaymentData.return_url,
                },
                metadata: {
                    paymentIntent: stripePaymentData.paymentIntent,
                },
            };

            checkAvailabilityThen(() => handleSourceActivation(sourceData));
        });

        /*
            Handles Payment Request API
        */

        var paymentRequest = stripe.paymentRequest({
            country: 'DE',
            currency: 'eur',
            total: {
                label: stripePaymentData.shopping_card_title,
                amount: stripePaymentData.amount,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });

        // Check the availability of the Payment Request API first and show correct payment method
        paymentRequest.canMakePayment().then(function(result) {
            console.log(result);
            if (result) {
                var allowGooglePay = result.googlePay ?? false;
                var allowApplePay = result.applePay ?? false;

                $('.stripe-google-pay').toggleClass('hidden', !allowGooglePay);
                $('.stripe-apple-pay').toggleClass('hidden', !allowApplePay);

            }
        });

        // on click of a payment request
        $(document).on('click', '.dnPaymentSelect-button-paymentRequest', function() {
            $(this).enableLoadingAnimation(true);
            checkAvailabilityThen(() => console.debug('Proceed with payment request'));
            paymentRequest.show()
        });

        // handle event cancel
        paymentRequest.on('cancel', function(ev) {
            handleLoadingButtons(false);
        });

        // handle event paymentmethod
        paymentRequest.on('paymentmethod', function(ev) {
            var paymentMethod = ev.paymentMethod.id;

            $.ajax({
                method: "POST",
                url: stripePaymentData.card_process_url,
                data: {
                    'payment_intent': stripePaymentData.paymentIntent,
                    'payment_method': paymentMethod
                },
            })
                .done(function(response) {
                    if (response.status === 'success') {
                        ev.complete('success');
                        window.location.replace(stripePaymentData.return_url);
                    }  else {
                        ev.complete('fail');
                        window.location.replace(stripePaymentData.rejected_payment_url);
                    }
                })
                .fail(function() {
                    window.location.replace(stripePaymentData.rejected_payment_url);
                });
        });


        // Create an instance of Elements.
        var elements = stripe.elements();

        var style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        var cardElement = elements.create('card', {style: style});
        var btnCreditCardPay = $("#dnPaymentStripe-creditCardPay");
        var errorMessageCreditCard = $("#dnPaymentSelect-description-errorsStripeCreditCard");

        // Add an instance of the card Element into the `card-element` <div>.
        cardElement.mount('#dnPaymentSelect-description-stripeCreditCardElement');

        $(document).on('click', '#' + btnCreditCardPay.attr('id'), function() {
            btnCreditCardPay.enableLoadingAnimation(true);
            errorMessageCreditCard.attr('hidden', true);

            checkAvailabilityThen( () => {
                stripe.createPaymentMethod({
                    type: 'card',
                    card: cardElement,
                    billing_details: {
                        name: stripePaymentData.lastname,
                    },
                }).then(stripeCreditCardPaymentMethodHandler);
            });
        });

        function stripeCreditCardPaymentMethodHandler(result) {
            if (result.error) {
                btnCreditCardPay.enableLoadingAnimation(false);
                errorMessageCreditCard.attr('hidden', false);

                if (window.checkoutInProgress) {
                    window.checkoutInProgress = false;
                }
            } else {
                stripeCreditCardHandleServerResponse(result.paymentMethod.id);
            }
        }

        function stripeCreditCardRequiresActionHandler(result) {
            if (result.error) {
                btnCreditCardPay.enableLoadingAnimation(false);
                errorMessageCreditCard.attr('hidden', false);
            } else {
                stripeCreditCardHandleServerResponse(result.paymentIntent.payment_method);
            }
        }

        function stripeCreditCardHandleServerResponse(paymentMethodId) {
            $.ajax({
                method: "POST",
                url: stripePaymentData.card_process_url,
                data: {
                    'payment_intent': stripePaymentData.paymentIntent,
                    'payment_method': paymentMethodId
                },
            })
                .done(function(response) {
                    if (response.status == 'success') {
                        window.location.replace(stripePaymentData.return_url);
                    } else if(response.status == 'error_redirect') {
                        window.location.replace(stripePaymentData.return_url);
                    } else if(response.status == 'requires_action') {
                        stripe.handleCardAction(
                            stripePaymentData.clientSecret
                        ).then(stripeCreditCardRequiresActionHandler);
                    } else {
                        location.reload();
                    }
                })
                .fail(function() {
                    location.reload();
                });
        }
    }
});
